import React from "react";
import { PASSWORD_RESET_V2 } from "../../config/featureFlags";
import ForgotPasswordV2 from "./ForgotPasswordV2";

// REACT_APP_PASSWORD_RESET_V2 picks the step-up Forgot Password (docs/specs/password-reset-stepup.md); off renders the
// old temp-key screen it is given, untouched. Used by the /reset-password route and the login page's modal.
const ForgotPasswordGate = ({ Legacy, inModal = false, ...props }) =>
  PASSWORD_RESET_V2 ? <ForgotPasswordV2 inModal={inModal} {...props} /> : <Legacy {...props} />;

export default ForgotPasswordGate;
